import React from 'react';

const HomePage: React.FC = () => {
  return (
    <div>
      <h1>Welcome to the Data Detective Trainer</h1>
      <p>Select a category from the navigation bar to start a challenge.</p>
    </div>
  );
};

export default HomePage;
